<template>
  <el-dialog
    title="修改类目"
    :visible.sync="visible"
    width="1000px"
    modal-append-to-selector='body' 
    append-to-selector="body"
    >
    <slot name="prediction-category">
      <div style="margin-bottom: 8px;">
        <PredictionCategory 
          ref="PredictionCategoryRef" 
          v-if="platform === 'fxg'" 
          :shopId.sync="shopId" 
          :platform.sync="platform" 
          :baseItemId.sync="baseItemId"
          source="category"
          @updateIds="emitChange"
        />
      </div>
    </slot>
    <div class="block-main">
      <el-popover
        placement="bottom-end"
        v-model="isShowPopover"
        width="960"
        trigger="manual">
        <div class="categoryList-wrap">
          <template v-if="categoryList.length">
            <div v-for="(item, index) in categoryList" :key="item.categoryId+index" class="text item" @click="handleSelect(item)">
              <span v-html="categoryText(item.categoryNameList)"></span>
            </div>
          </template>
          <template v-else>
            <div  class="item">暂无结果</div>
          </template>
        </div>
        <el-input 
          ref="inputVal"
          slot="reference" 
          placeholder="请输入类目关键词，支持模糊查询"
          v-model="queryTxt"
          @focus="showPopover"
          @blur="hidePopover"
          @input="debouncedSearch"
        ></el-input>
      </el-popover>
      <div class="cascader-wrap" v-loading="isSelectLoading">
        <el-cascader-panel
          ref="cascader"
          v-if="forceUpdate"
          v-model="value"
          :options="categoryOptions"
          :props="categoryProps"
          @expand-change="expandChange"
          @change="change">
          <template #default="{ data }">
            {{ (data || {}).name }}<span v-if="(data || {}).ifGray === 0" class="text-red">(灰度)</span>
          </template>
        </el-cascader-panel>
      </div>

      <div class="choosed-block">
        <span style="color:#b9b9b9">已选：</span>{{labels}}
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary" @click="handleSave">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {getPlatformCategoryByCidAndLv, getTMCategoryFn, getCategoryList} from '@/servers/prod/center'
import { cloneDeep, debounce } from 'lodash'
import PredictionCategory from "./predictionCategory.vue";
export default {
  components: {
    PredictionCategory
  },
  props: ['platform', 'shopId' ,'baseItemId'],
  data() {
    return {
      visible: false,
      categoryProps: {
        value: 'cid',
        label: 'name',
        lazy: true,
        lazyLoad: this.lazyLoad
      },
      categoryOptions: [],
      categoryIds: [],
      categoryNames: [],
      lastLevelCateGory: {},
      pathLabels: [],
      initOptionsLoading: false,
      cb: null,
      existIdList: null,
      getLabelsCB: null,
      casShow: true,
      oldLabels: '',
      hasChange: true,
      queryTxt: '',
      categoryList: [],
      isShowPopover: false,
      forceUpdate: false,
      isSelectLoading: false,
      isSearch: false,
      getPlatformCategoryByCidAndLv: this.platform == 'tm' ? getTMCategoryFn(this.shopId) : getPlatformCategoryByCidAndLv,
      // 缓存正则表达式避免重复创建
      regexCache: new Map(),
      // 防抖搜索函数
      debouncedSearch: null,
      // 请求取消token
      searchCancelToken: null
    }
  },
  computed: {
    value:{
      get() {
        return this.categoryIds.map(Number)
      },
      set(v) {
        this.categoryIds = [...v]
      }
    },
    labels() {
      return this.pathLabels.join(' > ')
    },
    categoryText() {
      return (categoryNameList) => {
        if (!categoryNameList || !categoryNameList.length) return '';
        
        let str = categoryNameList.join(' > ');
        const queryTxt = this.queryTxt;
        
        if (!queryTxt || !str) return str;
        
        // 使用缓存的正则表达式
        const cacheKey = queryTxt;
        let regexArray = this.regexCache.get(cacheKey);
        
        if (!regexArray) {
          // 复制过来的数据中间带有空格的，去除中间空格，字符之间用逗号隔开
          const inputvalue = queryTxt.replace(/\ +/g, ",");
          const keyWordArr = inputvalue.split(",").filter(Boolean);
          
          regexArray = keyWordArr.map(keyword => {
            // 转义特殊字符避免正则表达式错误
            const escapedKeyword = keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            return new RegExp(`(${escapedKeyword})`, 'gi');
          });
          
          // 限制缓存大小，避免内存泄露
          if (this.regexCache.size > 50) {
            const firstKey = this.regexCache.keys().next().value;
            this.regexCache.delete(firstKey);
          }
          this.regexCache.set(cacheKey, regexArray);
        }
        
        // 应用高亮
        regexArray.forEach((regex, index) => {
          const keyword = queryTxt.replace(/\ +/g, ",").split(",").filter(Boolean)[index];
          if (keyword) {
            str = str.replace(regex, '<span style="color:red;">$1</span>');
          }
        });
        
        return str;
      }
    }
  },
  watch: {
    value: {
      handler(newVal, oldVal) {
        // 避免不必要的更新
        if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
          return;
        }
        
        this.$nextTick(() => {
          if (newVal && Array.isArray(newVal)) {
            this.categoryNames = [...newVal]; // 使用展开运算符代替concat
          } else {
            this.categoryNames = [];
          }
          
          // 只在非搜索状态下更新标签
          if (!this.isSearch && newVal && newVal.length > 0) {
            this.changeLables(newVal);
          }
        });
      },
      deep: false // 由于是数组，不需要深度监听
    },
    shopId(v) {
      if (v) {
        this.getPlatformCategoryByCidAndLv = this.platform === 'tm' ? 
          getTMCategoryFn(this.shopId) : getPlatformCategoryByCidAndLv;
      }
    },
  },
  methods: {
    showPopover() {
      this.isShowPopover = true;
    },
    hidePopover() {
      this.isShowPopover = false
    },
    handleSelect(item) {
      if (!item) return;
      
      const { categoryIdList, leaf, categoryNameList, categories } = item;
      
      // 验证数据完整性
      if (!categoryIdList || !Array.isArray(categoryIdList) || 
          !categoryNameList || !Array.isArray(categoryNameList) ||
          !categories || !Array.isArray(categories)) {
        console.warn('选择的类目数据不完整');
        return;
      }
      
      this.isSearch = true;
      
      // 清理之前的数据
      this.categoryOptions = [];
      this.categoryList = [];
      this.queryTxt = '';
      this.isShowPopover = false;
      
      // 设置状态
      this.hasChange = leaf === 1;
      
      // 使用nextTick优化DOM更新
      this.$nextTick(() => {
        this.forceUpdate = false;
        this.$nextTick(() => {
          this.forceUpdate = true;
          
          // 设置数据
          this.categoryIds = [...categoryIdList]; // 创建新数组避免引用
          this.pathLabels = [...categoryNameList]; // 创建新数组避免引用
          this.lastLevelCateGory = categories.length > 0 ? 
            { ...categories[categories.length - 1] } : {}; // 深拷贝避免引用
          
          // 初始化选项
          this.initOptions();
        });
      });
    },
    emitChange(category){
      this.expandChange(category.ids)
      this.change(category.ids)
    },
    change(v) {
      this.categoryIds = v
      const firstCheckedNodes = this.$refs.cascader.getCheckedNodes()[0];
      if (firstCheckedNodes) {
        this.pathLabels = firstCheckedNodes.pathLabels
        this.lastLevelCateGory = firstCheckedNodes.data
        this.hasChange = true
      } else {
        this.$message({
          type: 'warning',
          message: '请重新选择，获取类目名称错误！', 
          duration: 5000
        })
        this.$refs.cascader.clearCheckedNodes();
      }
    },
    async searchCategory() {
      // 如果有正在进行的请求，取消它
      if (this.searchCancelToken) {
        this.searchCancelToken.cancel('新的搜索请求');
      }
      
      if (!this.queryTxt.trim()) {
        this.categoryList = [];
        return;
      }
      
      const convertMap = {
        'alibaba': '1688',
        // 'wxh': 'wxsph', 
      }
      
      const _params = {
        queryTxt: this.queryTxt.trim(),
        platformType: convertMap[this.platform] || this.platform,
        shopId: this.shopId,
        pageSize: 30
      }
      
      try {
        // 创建新的取消token
        this.searchCancelToken = this.$http?.CancelToken?.source?.() || null;
        const config = this.searchCancelToken ? { cancelToken: this.searchCancelToken.token } : {};
        
        const res = await getCategoryList(_params, config);
        if (res && res.records) {
          this.categoryList = res.records;
        } else {
          this.categoryList = [];
        }
      } catch (error) {
        if (error.message !== '新的搜索请求') {
          console.error('搜索类目失败:', error);
          this.categoryList = [];
        }
      } finally {
        this.searchCancelToken = null;
      }
    },
    expandChange(v) {
      if (this.hasChange) {
        this.hasChange = false
      }
      this.changeLables(v)
    },
    changeLables(v) {
      if (this.$refs.cascader) {
        const labels = this.getPathLabelsByIds(v);
        this.pathLabels = labels;
      }
    },
    getPathLabelsByIds(ids) {
      const labels = [];
      ids.forEach(id => {
          const node = this.$refs.cascader.getNodeByValue(id);
          if (node) {
              labels.push(node.getText());
          }
      });
      return labels;
    },
    // 初始化选项
    async initOptions() {
      this.initOptionsLoading = true
      if(this.isSearch) {
        this.isSelectLoading = true
      }
      try {
        let parentId = 0
        if(this.platform === 'xy') {
          parentId = 2
        }
        let level1 = await this.getPlatformCategoryByCidAndLv(parentId, 0, this.platform)
        this.handleBindData(level1)  // 移除chilren防止循环加载时重复
        let options = await this.loadOptions(level1, true)
        this.getLabelsCB && this.getLabelsCB(this.categoryNames, this.lastLevelCateGory)
        this.categoryOptions = [].concat(options)
        const firstCheckedNodes = this.$refs.cascader ? this.$refs.cascader.getCheckedNodes()[0] : {};
        this.pathLabels = firstCheckedNodes.pathLabels || []
        this.lastLevelCateGory = firstCheckedNodes.data || {}
      } catch (error) {
        
      } finally {
        this.initOptionsLoading = false;
        this.isSearch = false;
        this.isSelectLoading = false;
      } 
    },
    // 根据value值递归加载选项
    async loadOptions(category, isTop = false, depth = 0) {
      // 限制递归深度，避免无限递归和内存堆积
      if (depth > 10) {
        console.warn('递归深度超过限制，停止加载');
        return category;
      }
      
      if (!category || !Array.isArray(category)) {
        return [];
      }
      
      const array = [];
      
      // 使用for循环而不是forEach，便于错误处理
      for (let i = 0; i < category.length; i++) {
        const item = category[i];
        if (!item) continue;
        
        try {
          if (
            (isTop || item.leaf === 0) &&
            this.value.includes(item.cid) &&
            this.value.length
          ) {
            // categoryNames中的id -> 转为对应名字
            if (isTop) {
              this.categoryNames[0] = item.name;
            }
            
            const res = await this.getPlatformCategoryByCidAndLv(
              item.cid, 
              isTop ? 2 : item.level + 1, 
              this.platform
            );
            
            if (res && Array.isArray(res)) {
              this.handleBindData(res); // 移除children防止循环加载时重复
              
              // categoryNames中的id -> 转为对应名字
              let level = item.level + 1;
              if (['pdd', 'alibaba', 'yz'].includes(this.platform)) {
                level = level - 1; // 拼多多level是从0开始
              }
              
              const value_category = res.find(resItem => resItem.cid == this.categoryIds[level]);
              if (value_category) {
                this.categoryNames[level] = value_category.name;
                this.lastLevelCateGory = value_category;
              }
              
              // 递归加载子级，增加深度计数
              if (res.length > 0) {
                item.children = await this.loadOptions(res, false, depth + 1);
              }
            }
          }
          
          // 创建新对象避免直接修改原数据
          array.push({ ...item });
        } catch (error) {
          console.error('加载类目选项失败:', error);
          // 即使出错也要添加原始项目，避免数据丢失
          array.push({ ...item });
        }
      }
      
      return array;
    },
    async lazyLoad(node, resolve) {
      if (node.root) {
        resolve([])
      } else if (node.children && node.children.length) {
        resolve()
      } else {
        let res = await this.getPlatformCategoryByCidAndLv(node.value, node.level, this.platform)
        res = res ? res : []
        this.handleBindData(res) 
        resolve(res)
      }
    },
    method_open(categoryIds, cb, existIdList) {
      this.categoryIds = categoryIds
      this.visible = true
      this.forceUpdate = true
      this.cb = cb
      this.existIdList = existIdList
      this.initOptions()
    },
    method_getLabels(categoryIds, cb) {
      if (this.categoryIds.join(',') === categoryIds.join(',')) {
        return cb && cb(this.labels, this.lastLevelCateGory)
      }
      this.categoryIds = [].concat(categoryIds)
      this.getLabelsCB = cb
      this.initOptions()
    },
    method_clear() {
      this.categoryIds = []
    },
    handleSave() {
      if(!this.hasChange) return this.$message.error('请选择最后一级类目');
      if(this.existIdList && this.existIdList.includes(this.categoryIds[this.categoryIds.length - 1])) {
        this.$message.error('所选类目重复，请重新选择！');
        return;
      }
      const labels = this.labels.split(' > ');
      this.cb && this.cb([[].concat(this.categoryIds), labels, cloneDeep(this.lastLevelCateGory)])
      this.handleCancel();
    },
    // 无用的数据字段删除
    handleBindData(list) {
      list.forEach(item => {
        ['children', 'insby', 'instm', 'insbyName', 'markId', 'updby', 'updbyName', 'updtm'].forEach(key => {
          delete item[key]
        })
      })
    },
    handleCancel() {
      this.visible = false;
      
      // 取消正在进行的搜索请求
      if (this.searchCancelToken) {
        this.searchCancelToken.cancel('对话框关闭');
        this.searchCancelToken = null;
      }
      
      // 清理数据
      this.categoryOptions = [];
      this.categoryNames = [];
      this.pathLabels = [];
      this.categoryList = [];
      this.queryTxt = '';
      this.hasChange = true;
      this.forceUpdate = false;
      this.isShowPopover = false;
      this.isSearch = false;
      this.isSelectLoading = false;
      
      // 清理回调函数引用
      this.cb = null;
      this.getLabelsCB = null;
      this.existIdList = null;
    }
  },
  created() {
    // 初始化防抖搜索函数
    this.debouncedSearch = debounce(this.searchCategory, 300);
  },
  mounted() {
    this.categoryIds = []
  },
  beforeDestroy() {
    // 清理防抖函数
    if (this.debouncedSearch && this.debouncedSearch.cancel) {
      this.debouncedSearch.cancel();
    }
    
    // 取消正在进行的请求
    if (this.searchCancelToken) {
      this.searchCancelToken.cancel('组件销毁');
      this.searchCancelToken = null;
    }
    
    // 清理缓存
    if (this.regexCache) {
      this.regexCache.clear();
    }
    
    // 清理数据引用
    this.categoryOptions = null;
    this.categoryList = null;
    this.cb = null;
    this.getLabelsCB = null;
    this.existIdList = null;
  }
}
</script>

<style lang="scss" scoped>
.cascader-wrap {
  overflow-x: auto;
  margin-top: 8px;
  height: 50vh;

  & ::v-deep .el-cascader-menu:last-child {
    border-right: solid 1px #E4E7ED;
  }
  & ::v-deep .el-cascader-menu__wrap {
    height: 50vh;
  }
}
  .item {
    height: 34px;
    line-height: 34px;
  }
  .text{
    &:hover{
      cursor: pointer;
      background-color: #D6E4EE;
    }
  }

  .box-card {
    width: 480px;
  }
  .categoryList-wrap{
    max-height: 280px;
    overflow-y: auto;
  }
.choosed-block {
  border: 1px solid #E4E7ED;
  height: 36px;
  line-height: 36px;
  padding: 0 10px;
  margin-top: 8px
}
</style>